import { GameSetting, IServices } from "@netent/origin";
import { ISettingsState, ISettingState } from "@netent/playui";
import { Store } from "redux";
import { IAdapterSetting } from "../..";
import { IStoreAction, IStoreState } from "../../store";
import { FeatureStateCreator } from "../../types";
import { moneyTypeAsSetting } from "../moneyTypes";

export const settingsState: FeatureStateCreator<ISettingsState> = (
  services: IServices,
  store: Store<IStoreState, IStoreAction>
): ISettingsState => {
  const settings: ISettingState[] = store
    .getState()
    .gameSettings.filter((s: IAdapterSetting) => s.available !== false)
    .map(
      (s: IAdapterSetting): ISettingState =>
        ({
          key: s.key,
          name: s.name,
          value: services.gameSettings.getSetting(s.key as GameSetting)
        } as ISettingState)
    );

  const numOfMoneyTypes = services.money.getTypes().length;

  if (numOfMoneyTypes > 1) {
    // we ensure that "isCash" is the first setting in the UI
    const withMoneyType: ISettingState[] = [
      moneyTypeAsSetting(services),
      ...settings
    ];

    return { settings: [...withMoneyType] };
  } else {
    return { settings };
  }
};
